
import { Vue, Component } from "vue-property-decorator";
// Entities
import { Company, Profile } from "@/entities/index";
import { getDailyOrders } from "@/services";

@Component
export default class LeftCard extends Vue {
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  warehouseCode = this.warehouse;
  integrateStepZero = this.company.integrateStepZero;

  dailyOrders = 0;

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  get warehouse(): string {
    return this.$store.getters.warehouse;
  }

  async getDailyOrders(): Promise<void> {
    const { dailyOrders } = await getDailyOrders({
      client: this.client,
      warehouse: this.warehouseCode,
      integrateStepZero: this.integrateStepZero,
    });
    this.dailyOrders = dailyOrders;
  }
}
